import React from 'react'
import { ResponsiveSVG } from 'ui/acro'
import { CommunityCrossfit } from 'images/latest'

const CommunityCrossfitIcon = ({ color = 'black' }) => (
  <ResponsiveSVG
    width='45px'
    height='33px'
    className='unstyled'
    fill={color}
    SVG={CommunityCrossfit}
  />
)

export default CommunityCrossfitIcon
